/** Create a redux reducer without switch statements. Often used in combination with `callAPIMiddleware`
 * @param {string} baseType - the common name of the reducer, say 'TRADES'
 * @param {object} initialState - the inital state for the reducer
 * @param {object} handlers - map of names to reducer functions. The names will be PREPENDED to the baseType
 * @returns {function} - a reducer function
 * @example
 *     const tradesReducer = createReducer(
 *        'TRADES', // baseType
 *        { trades: [] }, // initialState
 *        { // map
 *          'REQ': (state, action) => Object.assign({}, state, { isFetching: true }), // for REQ_TRADES
 *          'CLEAR' ... // for CLEAR_TRADES
 *       }
 *    );
 */
export function createReducer(baseType, initialState, reducers) {
  function reducer(state, action) {
    if (state === void 0) {
      state = initialState;
    }
    var shortName = baseType ? action.type.replace("_" + baseType, '') : action.type;
    if (reducers.hasOwnProperty(shortName)) {
      return reducers[shortName](state, action);
    } else if (reducers.hasOwnProperty(action.type)) {
      return reducers[action.type](state, action);
    } else {
      return state;
    }
  }
  return reducer;
}